import { ReactNode } from "react";
import { Section } from "react-aria-components";
import cx from "classnames";

import styles from "./styles.module.css";

type DropdownMenuSectionProps = {
  children: ReactNode;
  className?: string;
};

const DropdownMenuSection = ({ children, className }: DropdownMenuSectionProps) => {
  return <Section className={cx(styles.section, className)}>{children}</Section>;
};

DropdownMenuSection.displayName = "DS.DropdownMenu.Section";

export default DropdownMenuSection;
